import {Component, Input, Output, EventEmitter, ViewChild, Pipe, PipeTransform, ViewChildren, QueryList, HostListener, OnChanges} from '@angular/core';
import { FormControl } from '@angular/forms';

import {UserService} from '../shared/user.service';
import {AssignmentsService} from '../shared/assignments.service';

@Component({
    selector: 'role-component',
    templateUrl: 'role.component.html'
})
export class RoleComponent {
    control = new FormControl();
    
    @Input() canEdit;
    @Input() selected;
    @Output() roleChange = new EventEmitter();

    roles = [
        {
            label: 'Writer',
            value: 'writer'
        },
        {
            label: 'Page Additions Writer',
            value: 'pageAddWriter'
        },
        {
            label: 'Editor',
            value: 'editor'
        },
        {
            label: 'DMC',
            value: 'dmc'
        },
        {
            label: 'Follower',
            value: ''
        }
    ];

    constructor(private userService: UserService, assignments: AssignmentsService) {
        this.control.valueChanges.subscribe(value => {
            this.roleChange.emit(value);
        });
    }
    ngAfterContentInit() {
        let roles = this.roles;
        let selected = this.selected;
        let selectedRole = roles[4];
        for(var i = 0; i < roles.length; i++) {
            let role = roles[i];
            if( role.value == selected ) {
                selectedRole = roles[i];
            }
        }
        this.control.setValue(selectedRole);
    }
}